require("./css/base.css");
require("./css/picker.less");

import C from "./js/conf.js";
import M from "./js/common.js";
import device from "./js/device.js";
import user from "./js/user.js";

import SJ from "scriptjs";

let initShare = function() {
  if (typeof window.wxShareConfig == "undefined") {
    M.wxShare();
  } else {
    M.wxShare(window.wxShareConfig);
  }
};

if (device.isWeixin) {
  if (typeof wx !== "undefined") {
    M.wxConfig();
    initShare();
    console.log(wx, "1wx");
  } else {
    SJ(["https://res.wx.qq.com/open/js/jweixin-1.6.0.js"], function(wx) {
      M.wxConfig();
      initShare();
      console.log(wx, "wx");
    });
  }
}

// if (device.isMininWx) {
//   const unionId = M.getUrlParam("unionId") || "";
//   const msisdn = M.getUrlParam("msisdn") || "";
//   const userId = M.getUrlParam("userId") || "";
//   const publicOpenId = M.getUrlParam("publicOpenId") || "";
//   const UserInfo = M.wsCache.get("UserInfo") || {};
//   if (msisdn && unionId) {
//     M.wsCache.set("openid", publicOpenId, { exp: C.sexp });
//     M.wsCache.set("UserInfo", {
//       ...UserInfo,
//       msisdn,
//       unionId,
//       userId,
//       publicOpenId,
//     });
//   }
// }

// //放置缓存url
// let hl_url_page = localStorage.getItem("hl_url_page");
// hl_url_page = hl_url_page ? JSON.parse(hl_url_page) : [];
// hl_url_page.push(window.location.href);
// localStorage.setItem("hl_url_page", JSON.stringify(hl_url_page));

let Rxports = {
  M,
  C,
  device,
  user,
};
export default Rxports;
